import { AlertMini, Modal, PrimaryButton, TeamCodeComponent, TeamSummary } from '@gameday/react-components/components'
import InputFieldItems from '@gameday/react-components/components/InputFieldItems'
import { RoktPlaceholder } from '@gameday/react-components/components/Rokt'
import StatusLabel from '@gameday/react-components/components/StatusLabel/index'
import theme from '@gameday/react-components/utils/theme'
import emailValidator from 'email-validator'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import { amountDisplay, formatDateTime } from '../../../../formats'
import MessagesAccordian from '../../Common/MessagesAccordian'
import { renderInstalmentLine } from '../../Common/PaymentGateway'
import styles from './styles.scss'

const StyledPrimaryButton = styled(PrimaryButton)`
  padding: 0;
  width: 200px;
  margin-top: 1em !important;
  background-color: ${props => props.buttonColour};
  color: ${props => props.buttonTextColour};
  &:hover {
    background-color: ${props => props.buttonColour} !important;
    color: ${props => props.buttonTextColour} !important;
  }
`

const StyledWrapperBorder = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${props => (props.color ? props.color : theme.colors.border)};
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '2em')};
  padding-bottom: 15px;
  /* border-top: 1px solid ${theme.colors.border}; */
  /* margin-top: 10px;
  padding-top: 15px; */

  h2 {
    margin-bottom: 10px !important;
  }
`

const OrderRow = ({ label, value }) => (
  <div className={styles.orderDetailsRow}>
    <div className={styles.orderDetailsLabel}>{label}:</div>
    <b className={styles.orderDetailsValue} value={value}>
      {value}
    </b>
  </div>
)

const methodMap = (type = '') => ({
  paypal: 'PayPal',
  braintree: type.replace(/([a-z])([A-Z])/g, '$1 $2'),
})

const SuccessComponent = ({
  goto,
  orderId,
  paymentData,
  paymentSuccessHeading,
  paymentSuccessMessage,
  paymentType,
  resetForm,
  resetVoucher,
  successMessage,
  user,
  paymentMethod,
  formSettings,
  confirmationMessages,
  teamSuccessMessages,
  orgAddress,
  roktConfiguration,
  formType,
  isTeamEvent,
  isTeamRego,
  teamData,
  sendRegistrationCode,
  teamCode,
  teamLogo,
  gatewayReference,
  paymentDate,
  paymentAmount,
  paymentMethodDescription,
  orderStatus,
}) => {
  const isTeam = isTeamEvent || isTeamRego
  const [shareOpen, setShareOpen] = useState(false)
  const [disableSaveModal, setDisableSaveModal] = useState(true)
  const [emailList, setEmailList] = useState([])
  const [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    if (isTeam && setDisableSaveModal) {
      setDisableSaveModal(emailList <= 0)
    }
  }, [emailList])

  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        setShowAlert(false)
      }, 3000)
    }
  }, [showAlert])

  const methodType = paymentMethodDescription || methodMap(paymentType)[paymentMethod.type]
  let method
  switch (methodType) {
    case 'Android Pay Card':
      method = 'Google Pay'
      break
    case 'Apple Pay Card':
      method = 'Apple Pay'
      break
    default:
      method = methodType
      break
  }

  const { email, firstName } = user
  const { city, state, postalCode, country } = orgAddress || {}

  const { currencyCode, total } = paymentData
  const { isInstalmentsPayment } = orderStatus || {}

  const { rawValue: amount } = total || {}

  const { enableRoktMembershipForm, enableRoktEventForm, enableRoktShopForm } = roktConfiguration || {}
  let showRoktPlacement = false
  let roktPage = 'registration_summary'

  switch (formType) {
    case 'event':
      showRoktPlacement = enableRoktEventForm
      roktPage = 'event_summary'
      break
    case 'membership':
      showRoktPlacement = enableRoktMembershipForm
      roktPage = 'registration_summary'
      break
    case 'shop':
      showRoktPlacement = enableRoktShopForm
      roktPage = 'shop_summary'
      break
  }

  const roktAttributes = {
    email,
    amount,
    experience: 'Purchase',
    currency: currencyCode,
    paymenttype: method || 'None',
    confirmationref: String(orderId),
    firstname: firstName,
    language: 'EN',
    zipcode: postalCode,
    city,
    state,
    country,
  }

  const { teamDetails } = teamData || {}
  const { name: teamName, teamEmail, teamPrimaryContact: teamContact } = teamDetails || {}

  if (process.env.NODE_ENV === 'development') {
    formSettings.landingPageLink = `http://localhost:3005/event/${formSettings.subdomain}`
  }

  const { landingPageLink = '' } = formSettings
  // biome-ignore lint/complexity/useOptionalChain: TODO
  if (landingPageLink && landingPageLink.includes('.events-test.mygameday.')) {
    formSettings.landingPageLink = `https://${formSettings.subdomain}.event-testing.mygameday.app`
  }

  const message =
    formType?.toLowerCase() === 'shop'
      ? 'Thanks for your shop purchase and payment!'
      : 'Thanks for your registration and payment!'

  const renderInstalments = (paymentData, orderStatus) => {
    const { total } = paymentData || {}
    const { instalments, currency } = orderStatus || {}

    const StyledDescription = styled.div`
      color: ${theme.colors.darkGrey};
      font-weight: ${theme.typography.fontWeightNormal};
      font-size: 12px;
      font-style: italic;
      padding-bottom: 15px;
    `
    const StyledLine = styled.div`
      > div {
        padding: 5px 15px;

        :last-child {
          font-weight: ${theme.typography.fontWeightBold};
        }
      }

      > :first-child {
        border: 1px solid ${theme.colors.green};
        background-color: ${theme.colors.lightGreen};
        padding: 15px;
        margin-bottom: 5px;

        span {
          color: ${theme.colors.green};
        }
      }
    `

    const StyledTotal = styled.span`
      color: ${theme.colors.slate};
      font-family: ${theme.typography.defaultFont};
      font-weight: ${theme.typography.fontWeightBold};
      text-align: left;
      display: block;
      font-size: 12px;
      margin-left: auto;
      margin-right: 5px;
    `

    // No place that stores credit card number.
    // const cardNumber = 1234 // Credit Card ending in {cardNumber}
    const balanceRemaining = total?.rawValue - instalments[0].amountRaw

    return (
      <>
        <h2 style={{ marginBottom: 10 }}>Instalment Payment Plan</h2>
        <StyledDescription>Payment schedule using saved payment method: {paymentMethod?.name}</StyledDescription>
        <StyledWrapperBorder color="#D9D9D9" marginBottom={'10px'}>
          <StyledLine>
            {instalments.map(({ instalmentLabel, instalmentDate, amount }, index) => {
              const newDescription = `${index === 0 ? 'Paid' : 'Due'} on ${instalmentDate}`
              return renderInstalmentLine(`${instalmentLabel}: `, newDescription, amount)
            })}
          </StyledLine>
        </StyledWrapperBorder>
        <StyledWrapperBorder color="#D9D9D9" marginBottom={'10px'}>
          <StyledTotal>Total: {amountDisplay(total?.rawValue || 0, currency, false)}</StyledTotal>
        </StyledWrapperBorder>
        <StyledTotal>Balance Remaining: {amountDisplay(balanceRemaining || 0, currency, false)}</StyledTotal>
      </>
    )
  }
  return (
    <>
      <AlertMini
        variant="success"
        duration={3000}
        onClose={() => {
          setShowAlert(false)
        }}
        open={showAlert}
        text="Email Sent!"
        size="md"
        marginBottom
      />

      <h1 className={styles.heading}>{paymentSuccessHeading ? paymentSuccessHeading : message}</h1>

      {paymentData.total?.rawValue > 0 ? (
        !paymentSuccessMessage ? (
          <p className={styles.boldText} style={{ marginBottom: '2em' }}>
            You will receive a copy of the payment receipt via email
            {user.email ? (
              <span>
                to <strong>{user.email}</strong>
              </span>
            ) : (
              'via email'
            )}
          </p>
        ) : (
          paymentSuccessMessage
        )
      ) : (
        <>
          {!successMessage ? (
            <p>
              Your registration has been submitted. You will receive a copy of the payment receipt via email
              {user.email ? (
                <span>
                  to <strong>{user.email}</strong>
                </span>
              ) : (
                'via email'
              )}
            </p>
          ) : (
            successMessage
          )}
          <div style={{ marginBottom: 20 }}>
            <OrderRow label="Order number" value={orderId || '10000'} />
          </div>
        </>
      )}

      {isTeamRego && (
        <StyledWrapperBorder>
          <div>
            <h2>Register as a member for your team!</h2>
            <TeamSummary
              teamName={teamName}
              teamCode={teamCode}
              teamEmail={teamEmail}
              teamContact={teamContact}
              teamLogo={teamLogo}
            />
            <TeamCodeComponent teamCode={teamCode} />
          </div>
          <div className={styles.buttonContainer}>
            <StyledPrimaryButton
              onClick={() => {
                setShareOpen(true)
              }}
              buttonColour={formSettings.buttonColour}
              buttonTextColour={formSettings.buttonTextColour}
            >
              Invite Team Members
            </StyledPrimaryButton>
            <StyledPrimaryButton
              onClick={() => {
                window.open(formSettings.landingPageLink.concat('/portal'))
              }}
              buttonColour={formSettings.buttonColour}
              buttonTextColour={formSettings.buttonTextColour}
            >
              Manage My Team
            </StyledPrimaryButton>
          </div>

          {shareOpen && (
            <Modal
              label="Invite Team Members"
              isShowBottomBar
              isOpen={shareOpen}
              isShowSaveButton
              okText="Send"
              disableSaveButton={disableSaveModal}
              handleModalClose={() => {
                setShareOpen(false)
              }}
              handleModalSubmit={() => {
                const payload = {
                  teamData,
                  recipients: emailList,
                }
                sendRegistrationCode(payload)
                setShareOpen(false)
                setShowAlert(true)
              }}
            >
              <p>Please Enter your team members emails below to share your team registration form with them.</p>
              <InputFieldItems
                items={emailList}
                onSubmit={value => {
                  setEmailList(value)
                }}
                errorText="The value you have entered is not a valid email address."
                onValidate={data => {
                  const { value } = data.state
                  return emailValidator.validate(value)
                }}
                label={"Add your friends' email addresses below."}
                placeholder="Please Enter..."
              />
            </Modal>
          )}

          <div className={styles.buttonContainer}>
            <StyledPrimaryButton
              onClick={() => {
                resetForm()
                resetVoucher()
                goto(0)
              }}
              data-testid="registerTeamMemberButton"
              buttonColour={formSettings.buttonColour}
              buttonTextColour={formSettings.buttonTextColour}
            >
              Register Team Member(s)
            </StyledPrimaryButton>
            <StyledPrimaryButton
              onClick={() => {
                window.open(formSettings.landingPageLink)
              }}
              buttonColour={formSettings.buttonColour}
              buttonTextColour={formSettings.buttonTextColour}
            >
              View Event
            </StyledPrimaryButton>
          </div>
        </StyledWrapperBorder>
      )}

      {paymentData.total?.rawValue > 0 && (
        <StyledWrapperBorder>
          <h2>Payment Confirmation</h2>
          <div>
            {orderStatus && !isInstalmentsPayment && (
              <OrderRow label="Order status" value={orderStatus.status || orderStatus} />
            )}
            {isInstalmentsPayment && (
              <OrderRow label="Order status" value={<StatusLabel label="Instalment Plan" variant="warning" />} />
            )}
            <OrderRow label="Order number" value={orderId || '10000'} />
            <OrderRow
              label="Payment Date"
              value={formatDateTime({
                applyStyling: true,
                value: paymentDate,
                style: 1,
                returnDateOnly: true,
              })}
            />
            {gatewayReference && <OrderRow label="Payment Gateway Reference" value={gatewayReference} />}
            <OrderRow label="Amount paid" value={paymentAmount || paymentData.total.value} />
            <OrderRow label="Payment method" value={method || 'Credit Card'} />
          </div>
        </StyledWrapperBorder>
      )}

      {isInstalmentsPayment && <StyledWrapperBorder>{renderInstalments(paymentData, orderStatus)}</StyledWrapperBorder>}

      {confirmationMessages && !isTeamRego && (
        <div className={styles.messages}>
          <MessagesAccordian messages={confirmationMessages} title="Messages from" />
        </div>
      )}
      {teamSuccessMessages && isTeamRego && (
        <div className={styles.messages}>
          <MessagesAccordian messages={teamSuccessMessages} title="Messages from" />
        </div>
      )}

      {showRoktPlacement && <RoktPlaceholder page={roktPage} attributes={roktAttributes} />}
    </>
  )
}

export default SuccessComponent
